import WebsiteEntertainmentProvider    from '@/components/WebsiteEntertainmentProvider';
import { ContextValue }                from '@/components/WebsiteEntertainmentProvider';
import { WebsiteEntertainmentContext } from '@/components/WebsiteEntertainmentProvider';
import appStore                        from '@/stores/appStore';
import { navigate }                    from '@widesk-ui/hooks/useNavigate';
import { FC }                          from 'react';
import { useContext }                  from 'react';
import { useParams }                   from 'react-router-dom';
import React                           from 'react';

const useParamsToWebsiteEntertainment = () => {
	const { websiteEntertainmentId } = useParams();

	React.useEffect(() => {
		if (websiteEntertainmentId) {
			void appStore.changeWebsiteEntertainment(websiteEntertainmentId);
		}
	}, [websiteEntertainmentId]);
};

const pathWithWebsiteEntertainment = (
	to: string,
	websiteEntertainmentId = appStore.websiteEntertainment?.id,
) => {
	return `/website_entertainments/${websiteEntertainmentId}${to}`;
};

const navigateWithWebsiteEntertainment = (to: string) => {
	if (!appStore.websiteEntertainment) {
		return navigate(`/`);
	}

	return navigate(pathWithWebsiteEntertainment(to));
};

const useWebsiteEntertainment = (): ContextValue => {
	return useContext(WebsiteEntertainmentContext);
};

export {
	useParamsToWebsiteEntertainment,
	navigateWithWebsiteEntertainment,
	pathWithWebsiteEntertainment,
};

export const withWebsiteEntertainment = (WrappedComponent: FC) => (props: Record<string, unknown>) => {
	return (
		<WebsiteEntertainmentProvider>
			<WrappedComponent {...props} />
		</WebsiteEntertainmentProvider>
	);
};

export default useWebsiteEntertainment;
